import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconAnalyticsGraph';
/** Renders an SVG icon. */
const SvgAnalyticsGraph = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M5 4a1 1 0 0 1 1 1v20a1 1 0 0 0 1 1h20a1 1 0 1 1 0 2H7a3 3 0 0 1-3-3V5a1 1 0 0 1 1-1"
      />
      <path
        fill="currentColor"
        d="M14 11a2 2 0 1 1-4 0 2 2 0 0 1 4 0m8 3a2 2 0 1 1-4 0 2 2 0 0 1 4 0m4-8a2 2 0 1 1-4 0 2 2 0 0 1 4 0M14 21a2 2 0 1 1-4 0 2 2 0 0 1 4 0m7 0a2 2 0 1 1-4 0 2 2 0 0 1 4 0m6-4a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M24.447 5.106a1 1 0 0 1 .447 1.341l-4.402 8.805-8.294-3.11-6.815 5.767-1.292-1.526 7.71-6.525 7.707 2.89 3.598-7.195a1 1 0 0 1 1.341-.447m1.385 11.339a1 1 0 0 1-.277 1.387L19.303 22h-7.117l-7.26 2.792-.718-1.866L11.814 20h6.883l5.748-3.832a1 1 0 0 1 1.387.277"
      />
    </svg>
  );
};
SvgAnalyticsGraph.displayName = displayName;
export default SvgAnalyticsGraph;
